import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  footer: {
    pt: ['10', null, '6'],
    bg: 'transparent',
    color: 'white',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    h: '70px',
    pr: '0',
    mb: ['12', '6'],
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
    sx: {
      '& > img': {
        maxW: '222px',
        maxH: '50px',
        ml: '0',
      },
    },
  },
  footerLink: {
    color: 'gamma.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerLinkService: {
    color: 'gamma.500',
  },
  footerLinkTel: {
    color: 'gamma.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  customFooterLink: {
    color: 'gamma.500',
    textTransform: 'capitalize',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontSize: 'base',
  },
  footerLinks: {
    mt: '3',
    ml: ['unset', null, 'auto'],
    pb: ['4', null, '0'],
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'white',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
  },
  footerContentContainer: {
    px: ['2.5', 'unset'],
    pt: ['3', 'unset'],
    gap: '6',
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: 'column',
      },
    },
  },
  nav: {
    fontSize: 'sm',
    fontWeight: 'medium',
    minW: [null, null, '370px'],
    mt: ['1', 'unset'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '28',
    rowGap: '4',
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
      ". ."
    `,

    '> a': {
      color: 'inherit',
    },
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'white',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '0'],
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
    color: 'white',
  },
  blurbHeadingAge: {
    borderColor: 'blackAlpha.50',
    border: '4px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
  },
  blurbHeadingThink: {
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '4',
  },
  blurbContent: {
    ml: 'unset',
    mr: [null, null, 'auto'],
    color: 'white',
  },
  copyright: {
    textAlign: ['center', 'left'],
    mt: ['7'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
    color: 'white',
  },
  container: {
    sx: {
      '&&': {
        px: '0',
      },
    },
  },
  emailUs: {
    fontSize: 'md',
    fontWeight: 'bold',
  },
  footerDownloadImage: {
    border: '2px',
    borderColor: 'white',
    borderRadius: 'md',
    filter: 'drop-shadow(0px 2px 7px rgba(0, 0, 0, 0.3))',
  },
  partnerWrapper: {
    mr: 'unset',
  },
  quickLinks: {
    color: 'white',
    textTransform: ['inherit', 'none'],
    textAlign: ['center', 'left'],
    fontSize: ['lg', 'md'],
  },
  ourPartners: {
    fontSize: ['lg', 'md'],
    color: 'white',
    textTransform: ['inherit', 'none'],
  },
  weAccept: {
    fontSize: ['lg', 'md'],
    color: 'white',
    textTransform: ['inherit', 'none'],
  },
};
